import { useEvent } from "../../../lib/hooks/useEvent";

const RenderWeeks = ({
    setWeeks,
    weeks
}) => {
  const { event } = useEvent();

  return (
    <div className="col-3">
      {!!event?.isActive && (
        <>
          {[...Array(event?.num_weeks)].map((_, index) => (
            <button
              key={`week${index + 1}`}
              className={`circle-button ${
                weeks === `isSelectedWeek${index + 1}`
                  ? `week${index + 1}-button-focused`
                  : `week${index + 1}-button`
              }`}
              id={`week${index + 1}`}
              onClick={() => {
                if (weeks === `isSelectedWeek${index + 1}`) setWeeks("none");
                else setWeeks(`isSelectedWeek${index + 1}`);
              }}
              style={{ marginRight: "3px", marginBottom: "15px" }}
            >
              {index + 1}
            </button>
          ))}
          <button
            className={`circle-button 
              ${
                weeks === "all"
                  ? "all-weeks-button-focused"
                  : "all-weeks-button"
              }`}
            id="allweeks"
            onClick={() => {
              if (weeks === "all") setWeeks("none");
              else setWeeks("all");
            }}
          >
            All
          </button>
        </>
      )}
    </div>
  );
};

export default RenderWeeks;
